import { useMemo, useState } from 'react';
import { getContainer } from '@framework/di/getContainer';
import RoadshowRepository from '@drs/infrastructure/repository/RoadshowRepository';
import ReviewModeService from './ReviewModeService';
import { AlertManager } from '@dealroadshow/uikit-alert';
import { getErrorMessage } from '@framework/message/Mapper/getMessage';
import RoadshowType from '@drs/domain/RoadshowType';

const useRoadshow = () => {
  const container = getContainer();
  const roadshowRepository = container.get<RoadshowRepository>(RoadshowRepository);
  const viewerReviewModeService = container.get<ReviewModeService>(ReviewModeService);

  const [roadshow, setRoadshow] = useState<any>({});
  const [roadshowId, setRoadshowId] = useState(null);
  const [entryCode, setEntryCode] = useState(null);

  const getRetailRoadshowById = async (roadshowId: string) => {
    try {
      const roadshow = await roadshowRepository.getPresentableRetailRoadshowById(roadshowId);
      setRoadshow(roadshow);
      // @ts-ignore
      setRoadshowId(roadshowId);
      return roadshow;
    } catch (error) {
      AlertManager.error(getErrorMessage(error));
      throw error;
    }
  };

  const getPreviewRoadshowById = async (roadshowId: string) => {
    try {
      const roadshow = await roadshowRepository.getPreviewPresentableRoadshowById(roadshowId);
      setRoadshow(roadshow);
      // @ts-ignore
      setRoadshowId(roadshowId);
      return roadshow;
    } catch (error) {
      AlertManager.error(getErrorMessage(error));
      throw error;
    }
  };

  const getRoadshowById = async (roadshowId: string) => {
    try {
      const roadshow = await roadshowRepository.getPresentableRoadshowById(roadshowId);
      setRoadshow(roadshow);
      // @ts-ignore
      setRoadshowId(roadshowId);
      return roadshow;
    } catch (error) {
      AlertManager.error(getErrorMessage(error));
      throw error;
    }
  };

  const getRoadshowByEntryCode = async (entryCode: string) => {
    // eslint-disable-next-line no-useless-catch
    try {
      const roadshow = await roadshowRepository.getPresentableRoadshowByEntryCode(entryCode);
      setRoadshow(roadshow);
      setRoadshowId(roadshow.id);
      // @ts-ignore
      setEntryCode(entryCode);
      return roadshow;
    } catch (error) {
      throw error;
    }
  };

  const isModerated = roadshow.moderated;
  const isSlidesAndVideo = RoadshowType.isSlidesAndVideo(roadshow.type);
  const isSlidesAndAudio = RoadshowType.isSlidesAndAudio(roadshow.type);
  const isVideoOnly = RoadshowType.isVideoOnly(roadshow.type);
  const isLiveVideo = RoadshowType.isLiveVideo(roadshow.type);
  const isSlides = RoadshowType.isSlides(roadshow.type);
  const hasPresentationMedia = RoadshowType.hasPresentationMedia(roadshow.type);

  return useMemo(() => ({
    roadshow,
    entryCode,
    roadshowId,
    isModerated,
    isSlidesAndVideo,
    isSlidesAndAudio,
    isVideoOnly,
    isLiveVideo,
    isSlides,
    hasPresentationMedia,
    getRetailRoadshowById,
    getPreviewRoadshowById,
    getRoadshowById,
    getRoadshowByEntryCode,
    setRoadshow,
    setReviewMode: viewerReviewModeService.setReviewMode,
    getReviewMode: viewerReviewModeService.getReviewMode,
    clearReviewMode: viewerReviewModeService.clearReviewMode,
  }),
  [roadshow, roadshowId, entryCode]);
};

export default useRoadshow;
